import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,[_c(VListItemContent,[_vm._v(" "+_vm._s(_vm.companyPair.company.name)+" ")]),_c(VListItemAction,[_c(VSwitch,{attrs:{"dense":""},on:{"change":_vm.handleActiveChange},model:{value:(_vm.companyPair.active),callback:function ($$v) {_vm.$set(_vm.companyPair, "active", $$v)},expression:"companyPair.active"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }